import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const localesList = []
const currentLng = process.env.VUE_APP_I18N_LOCALE

function loadLocaleMessages () {
  const locales = require.context('./i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([a-z0-9]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      localesList.push(locale)
      messages[locale] = locales(key)
      // add localization for validations
      messages[locale].validations = require('vee-validate/dist/locale/' + locale).messages
    }
  })
  return messages
}

function getLocale () {
  return i18n.locale
}
const messages = loadLocaleMessages()
const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || currentLng,
  messages: messages
})

export { i18n, localesList, getLocale }
